import React, {Component} from 'react';
import "../common.css"
import "./index.css"
import {Button, Col, Container, Row} from "reactstrap";
import {Field, formValueSelector, reduxForm, submit} from "redux-form";
import {connect} from "react-redux";
import * as actions from "../../../../actions";
import {required} from "../../../../util/utility";
import formEl from "../../../../util/form";
import assets from "../../../../util/assets";
import api from "../../../../util/clipstore/broadcaster/library";
import util from "../../../../util/clipstore/broadcaster/create";
import {clipstoreContentPriceList} from "../../../../util/broadcaster/profile_util";

class CreateGalleryPage extends Component {

    constructor() {
        super();

        this.state = {
            title: '',
            count: 0,
            titleCount: 0,
            currentGalleryId: null,
            currentGallery: null,
            thumbnailImage: null,
            submitPassed: false,
            content: {
                payload: null
            },
            id: "",
            preview: assets.clipstore.gallery_placeholder,
            content_type: "free",
            include_in_subscription: "false",
            contentPriceOptionTemplate: clipstoreContentPriceList().map((v) => (
                <option key={v} value={v}>
                    {`£ ${v}`}
                </option>
            )),
        };


        //all the functions used in this component should be listed here for better documentation
        this.onSelectFile = this.onSelectFile.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onSave = this.onSave.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
    }

    componentDidMount() {

    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.add_edit_pricing_content && nextProps.add_edit_pricing_content.payload !== this.state.content.payload) {

            let payload = nextProps.add_edit_pricing_content.payload;
            payload = payload.hasOwnProperty("gallery") ? null : payload;

            if(payload){
                this.setState({
                    content: nextProps.add_edit_pricing_content,
                    id: payload && payload.id,
                    preview: payload && payload.thumbnail_url,
                    titleCount:payload && payload.title.length,
                    count:payload && payload.description.length,
                    content_type: payload.pricing.type,
                    include_in_subscription: payload.pricing.part_of_subscription === "yes" ? "true" : "false",
                },()=>{
                    let entire_content_price_value = document.getElementsByName("entire_content_price_value");
                    if (entire_content_price_value[0]) {
                        entire_content_price_value[0].value = parseInt(payload.pricing.price / 100)
                    }
                })
            }
        }

        //handle the API response for publishing the videos
        api.handleAPIResponse(nextProps, "add_gallery", () => {
            //reset the payload value as we have captured the event
            this.props.resetAddGallery();
        }, () => {
            this.props.toggle("refresh")
        }, () => {
            //nothing to handle
        })

        //handle the API response for publishing the videos
        api.handleAPIResponse(nextProps, "edit_gallery", () => {
            //reset the payload value as we have captured the event
            this.props.resetEditGallery();
        }, () => {
            this.props.toggle("refresh")
        }, () => {
            //nothing to handle
        })
    }

    onSelectFile = e => {

        if (e.target.files && e.target.files.length > 0) {
            this.setState({
                thumbnailImage: e.target.files[0],
                preview: URL.createObjectURL(e.target.files[0])
            });
        }
    }
    goBack = () => {
        this.props.history.push("/broadcaster/my-library");
    }

    setCurrentGalleryId = (id) => {
        this.setState({
            currentGalleryId: id
        })
    }

    resetCurrentGalleryId = () => {
        this.setCurrentGalleryId(null);
    }

    onKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); //<===== This stops the form from being submitted
        }
    }

    onSubmit(values) {

        this.setState({
            submitPassed: true
        })


        if(this.state.thumbnailImage === null && this.state.preview.indexOf("https://dgsnexqo3t7f4.cloudfront.net") === -1){
            return;
        }

        const formData = new FormData();
        formData.append("title", values.title);
        formData.append("description", values.description);
        formData.append("age_group", values.age_group);
        formData.append("type", values.content_type);

        if(this.state.thumbnailImage !== null){
            formData.append("thumbnail", this.state.thumbnailImage);
        }

        if(values.content_type !== "free"){
            formData.append("price", api.formatPriceForAPI(document.getElementsByName("entire_content_price_value")[0].value));
        }

        if (values.content_type === "free") {
            formData.append("part_of_subscription", "yes");
        } else {
            formData.append("part_of_subscription", document.getElementsByName("include_in_subscription")[0].value === "true" ? "yes" : "no")
        }

        formData.append("device[platform]", this.props.device.platform);
        formData.append("device[name]", this.props.device.name);
        formData.append("device[version]", this.props.device.version);
        formData.append("device[ip]", this.props.device.ip);
        formData.append("device[id]", this.props.device.id);
        formData.append("device[app_version]", this.props.device.app_version);
        formData.append("device[device_token]", this.props.device.device_token);

        if (this.state.id === "") {
            api.addGalleryAPI(this.props, formData);
        } else {
            api.editGalleryAPI(this.props,this.state.id, formData);
        }
    }

    onCancel() {
        if (this.state.id === "") {
            this.props.history.push("/broadcaster/my-library")
        } else {
            this.props.toggle()
        }
    }

    handleChange = (event, newValue, previousValue, name) => {

        this.props.dispatch(this.props.change(name, newValue));
        let obj = {};
        obj[name] = "" + newValue;

        this.setState(obj);
    }

    onSave() {
        setTimeout(() => {
            this.props.dispatch(submit('createGalleryContentForm'))
        }, 100)
    }

    onChange = (value) => {
    }

    handleOnBlur(event, newValue, previousValue, name) {
        /**
         * setTimeout is needed so that the dispatch can be called
         * */
        setTimeout(() => {
            const newData = util.filterProfanity(this.props, name, newValue);
            this.setState({
                title: newData,
                titleCount: newData.length,
            });
        }, 0);
    };

    textAreaChange(event, newValue, previousValue, name) {
        /**
         * setTimeout is needed so that the dispatch can be called
         * */
        setTimeout(() => {
            const newData = util.filterProfanity(this.props, name, newValue);
            this.setState({
                count: newData.length,
            })
        }, 0);
    }

    render() {
        const {handleSubmit} = this.props;

        return (


            <Container className="row">

                <div className="wrapper">

                    <form onSubmit={handleSubmit(this.onSubmit.bind(this))}
                          onKeyPress={this.onKeyPress}
                          className="edit-video-form gallery-modal-form">

                        <Row>
                            <Col md={5}>

                                <input ref='file'
                                       type='file'
                                       id="gallery-thumbnail-file"
                                       name="thumbnail"
                                       accept="image/*"
                                       style={{display: 'none'}}
                                       onChange={this.onSelectFile}/>

                                <div className="create-gallery-upload-gallery-image-container">
                                    <div>
                                        <img src={this.state.preview} alt="gallery thumbnail preview"
                                             className="create-gallery-upload-gallery-image"/>
                                        {
                                            this.state.thumbnailImage === null &&
                                            this.state.submitPassed &&
                                            <div className="custom-form-text-danger">Required</div>
                                        }
                                    </div>
                                    <div className="create-gallery-upload-gallery-image-ghost-btn" onClick={() => {
                                        document.getElementById("gallery-thumbnail-file").click()
                                    }}>Upload gallery image
                                    </div>
                                </div>
                                {/*Enter session title*/}
                                <Field
                                    label="Gallery name"
                                    name="title"
                                    placeholder="Please enter title here..."
                                    type="text"
                                    maxLength="40"
                                    count={this.state.titleCount}
                                    onBlur={this.handleOnBlur}
                                    onChange={this.handleOnBlur}
                                    height={"49px"}
                                    validate={[required]}
                                    countAtBottom={true}
                                    component={formEl.renderInputField}
                                />
                                {/*Enter session title*/}

                                {/*Enter session description*/}
                                <Field
                                    label="Gallery Description"
                                    name="description"
                                    placeholder="Please enter description here..."
                                    maxLength="280"
                                    minLength="1"
                                    onBlur={this.textAreaChange}
                                    height={"153px"}
                                    count={this.state.count}
                                    validate={[required]}
                                    countAtBottom={true}
                                    component={formEl.renderTextAreaField}
                                    onChange={this.textAreaChange}
                                />
                                {/*Enter session description*/}

                                {/*Age rating*/}
                                <div>
                                    <label className="label-14">
                                        Select age group
                                        <a href="https://www.bbfc.co.uk/about-classification/classification-guidelines"
                                           target="_blank">
                                            <img alt={"close-icon"} width="18" src={assets.information}/>
                                        </a>
                                    </label>
                                </div>
                                <div className="form-group">
                                    <label className="ageGroup">
                                        <Field
                                            name="age_group"
                                            component="input"
                                            type="radio"
                                            validate={[required]}
                                            value="less_than_12"
                                        />{" "}
                                        Under 12
                                    </label>
                                    <label className="ageGroup">
                                        <Field
                                            name="age_group"
                                            component="input"
                                            type="radio"
                                            validate={[required]}
                                            value="more_than_12"
                                        />{" "}
                                        12+
                                    </label>
                                    <label className="ageGroup">
                                        <Field
                                            name="age_group"
                                            component="input"
                                            type="radio"
                                            validate={[required]}
                                            value="more_than_15"
                                        />{" "}
                                        15+
                                    </label>
                                    <label className="ageGroup">
                                        <Field
                                            name="age_group"
                                            component="input"
                                            type="radio"
                                            validate={[required]}
                                            value="18"
                                        />{" "}
                                        18
                                    </label>
                                </div>
                                {/*Age rating*/}

                            </Col>

                            <Col md={2} className="gallery-modal-vertical-line"/>

                            <Col md={5} className="pricing-column">
                                <dt className="label-14">Content Type</dt>
                                <dd>
                                    <label className="broadcastType">
                                        <Field
                                            label="Free"
                                            name="content_type"
                                            type="radio"
                                            value="free"
                                            checked={this.state.content_type === "free"}
                                            validate={[required]}
                                            component={formEl.renderRadioField}
                                            onChange={this.handleChange}
                                        />
                                    </label>
                                    <label className="broadcastType">
                                        <Field
                                            label="Paid"
                                            name="content_type"
                                            type="radio"
                                            value="paid"
                                            checked={this.state.content_type === "paid"}
                                            validate={[required]}
                                            component={formEl.renderRadioField}
                                            onChange={this.handleChange}
                                        />
                                    </label>
                                </dd>

                                <dt className="by-selecting-paid-op">By selecting paid option, you can able to set price
                                    for
                                    your Content only for unsubscribed users & free for subscribed users.
                                </dt>
                                <br/>

                                {
                                    this.state.content_type === "paid" &&
                                    <div>
                                        <Row>
                                            <Col md="12">
                                                <dt className="label-14">Pricing for gallery</dt>
                                                <dd>
                                                    {/*Entire Content Price*/}
                                                    <Row>
                                                        <Col md="7">
                                                            <Field
                                                                className="custom-select"
                                                                name="entire_content_price_value"
                                                                component="select">
                                                                {this.state.contentPriceOptionTemplate}
                                                            </Field>
                                                        </Col>
                                                        <Col md="4" className="no-margin no-padding">
                                                            <div style={{marginTop: 6}}>video</div>
                                                        </Col>
                                                    </Row>
                                                </dd>
                                                {/*Entire Content Price*/}
                                            </Col>

                                        </Row>

                                        {/*Include in subscription*/}
                                        <Row style={{marginTop: 16}}>
                                            <Col md="12">
                                                <label className="broadcastType">
                                                    <Field
                                                        label="Include in subscription"
                                                        name="include_in_subscription"
                                                        type="checkbox"
                                                        checked={this.state.include_in_subscription === "true"}
                                                        component={formEl.renderCheckBoxField}
                                                        onChange={this.handleChange}
                                                    />
                                                    <div className="by-selecting-paid-op">
                                                        By selecting this option, the content you are uploading will be
                                                        free for
                                                        subscribed users
                                                    </div>
                                                </label>
                                            </Col>
                                        </Row>
                                        {/*Include in subscription*/}
                                    </div>
                                }
                            </Col>
                        </Row>

                        <div className="gallery-modal-horizontal-line"/>
                        <Row className="display-flex-end no-margin create-gallery-upload-footer button-container">

                            <Col sm="12"
                                 className="no-padding  text-align-right">
                                <Button color="outline-secondary" onClick={()=>{
                                    this.props.toggle();
                                }}>
                                    CANCEL
                                </Button>

                                <Button color="primary">
                                    {
                                        (this.props.add_gallery.isFetching || this.props.edit_gallery.isFetching)
                                            ?
                                            <img
                                                src={assets.loading_white}
                                                alt={"Loading"}
                                                width={26}
                                                height={26}
                                            />
                                            :
                                            this.props.hasOwnProperty("editMode") && this.props.editMode ? "SAVE CHANGES" : "CREATE"
                                    }

                                </Button>
                            </Col>
                        </Row>
                    </form>
                </div>


            </Container>

        );
    }
}

function mapStateToProps(state) {

    const selector = formValueSelector("createGalleryContentForm");
    let payload = state.clipstore_broadcaster_add_edit_pricing_content && state.clipstore_broadcaster_add_edit_pricing_content.hasOwnProperty("payload") && state.clipstore_broadcaster_add_edit_pricing_content.payload;
    payload = payload && payload.hasOwnProperty("gallery") ? null : payload;

    return {
        initialValues: {
            thumbnailImage: payload && payload.thumbnail,
            title: payload && payload.title,
            description: payload && payload.description,
            age_group: payload && payload.age_group,
        },
        account_management: state.account_management,
        device: state.device.payload,
        profanity: state.profanity.words,
        add_gallery: state.clipstore_broadcaster_reducer_add_gallery,
        edit_gallery: state.clipstore_broadcaster_reducer_edit_gallery,
        add_edit_pricing_content: state.clipstore_broadcaster_add_edit_pricing_content,
    }
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
CreateGalleryPage = reduxForm({
    form: "createGalleryContentForm", // a unique identifier for this form
    enableReinitialize: true,
})(CreateGalleryPage);

// You have to connect() to any reducers that you wish to connect to yourself
CreateGalleryPage = connect(
    mapStateToProps, // pull initial values from account reducer
    actions // bind account loading action creator
)(CreateGalleryPage);

export default CreateGalleryPage;